import React, { useState } from 'react'
import { css } from '@linaria/core'
import { Paragraph, ChoiceChips, ActionChip, DialogOverlay, useOverlay, Row, Grid, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@fs/zion-analytics'
import MeaningDisplay from './MeaningDisplay'

const actionChipsCss = css`
  display: inline;
  margin-right: 13px;
`

function NameVariantChips({ variants, setVariantType, overlay }) {
  let index = 0
  return (
    <Row wrap gutters="nano" guttersY="xxs">
      {variants.map((v) => {
        const variantName = v?.name
        const variantIndex = index
        index++
        return (
          <div key={variantIndex} className={actionChipsCss}>
            <ActionChip
              data-testid="variant-name-overlay-action"
              label={variantName}
              onClick={() => {
                trackEvent({ link_name: 'Name Meaning: Name Variant Chip' })
                setVariantType(variantIndex)
                overlay.handleClick()
              }}
            />
          </div>
        )
      })}
    </Row>
  )
}

export default function MeaningBody({ meanings }) {
  const [t] = useTranslation()
  const overlay = useOverlay()
  const [nameType, setNameType] = useState(Object.keys(meanings)[0])
  const variants = meanings[nameType]?.variants
  const initialVariant = variants?.length > 0 ? Object.keys(variants)[0] : undefined
  const [variantType, setVariantType] = useState(initialVariant)
  const attribution = meanings[nameType]?.attribution
  const onSelectionChange = (newSelectedChip) => {
    setNameType(newSelectedChip.value)
    if (variants?.length > 0) {
      setVariantType(Object.keys(variants)[0])
    }
    trackEvent({ link_name: 'Name Meaning: Name Chip' })
  }
  const chips = Object.entries(meanings).reduce((acc, [key, value]) => {
    if (value?.name) {
      acc.push({
        label: value?.name,
        value: key,
        selected: key === nameType,
      })
    }
    return acc
  }, [])

  const meaningsArray = meanings[nameType]?.meanings
  const variantMeaningsArray = variants[variantType]?.meanings
  const emptyMessage = <Paragraph size="sm">{t('info-cards.name-meaning.no-info')}</Paragraph>

  return (
    <>
      <ChoiceChips chips={chips} onSelectionChange={onSelectionChange} name="Names" />

      <Grid guttersY="sm">
        {meaningsArray?.map((meaning, index) => {
          const meaningKey = `meaning-${nameType}-${index}`
          return <MeaningDisplay key={meaningKey} meaning={meaning} />
        })}
        {meaningsArray?.length === 0 && emptyMessage}
      </Grid>

      <Separator size="sm" />

      {attribution && <Paragraph size="xs">{attribution}</Paragraph>}
      {variants?.length > 0 && (
        <>
          <Paragraph as="strong" size="sm">
            {t('info-cards.possible-related-names.label')}
          </Paragraph>
          <Separator size="xxs" />
        </>
      )}
      {variants?.length > 0 && (
        <NameVariantChips variants={variants} setVariantType={setVariantType} overlay={overlay} />
      )}
      {variants?.length > 0 && (
        <DialogOverlay {...overlay} title={variants[variantType]?.name}>
          {variantMeaningsArray?.map((m, index) => {
            const variantMeaningKey = `variant-meaning-${index}`
            return <Paragraph key={variantMeaningKey} dangerouslySetInnerHTML={{ __html: m }} size="sm" />
          })}
          {(!variantMeaningsArray || variantMeaningsArray?.length === 0) && emptyMessage}
          {variantMeaningsArray && variantMeaningsArray?.length !== 0 && attribution && (
            <Paragraph size="xs">{attribution}</Paragraph>
          )}
        </DialogOverlay>
      )}
    </>
  )
}
